import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fromJS } from "immutable";
import { getBaseUrl } from "../../api/api";
import BillingAction from "../../actions/BillingAction";

const PaymentCard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const paymentMethod =
    useSelector((state: any) => state.billingReducer.get("paymentMethod")) || fromJS({});

  useEffect(() => {
    dispatch(BillingAction.getBillingPaymentMethod());
  }, [dispatch]);

  const getUrlCardByBrand = (brand: string) => {
    let logo = "stripe_logo.png";
    switch ((brand || "").toLowerCase()) {
      case "stripe":
        logo = "stripe_logo.png";
        break;
      case "visa":
        logo = "visa_inc.png";
        break;
      case "paypal":
        logo = "paypal.png";
        break;
      case "mastercard":
        logo = "mastercard.png";
        break;
      case "jcb":
        logo = "jcb.png";
        break;
      case "discover":
        logo = "discover_card.png";
        break;
      case "unionpay":
        logo = "unionpay.png";
        break;
      case "girocard":
        logo = "girocard.png";
        break;
      case "eftpos":
        logo = "eftpos_logo.png";
        break;
      case "diners_club":
        logo = "diners_club_logo.png";
        break;
      case "dinacard":
        logo = "dina_card.png";
        break;
      case "cartes_bancaires":
        logo = "cartes_bancaires_logo.png";
        break;
      case "bc_card":
        logo = "bc_card.png";
        break;
      case "american_express":
        logo = "american_express_logo.png";
        break;
      default:
        break;
    }
    return getBaseUrl() + "/static/images/card/" + logo;
  };

  const renderHeader = () => {
    return (
      <div className="flex items-start justify-between p-3">
        <div>
          <div className="text-[12px] font-semibold leading-4 text-gray-900">{t("Payment")}</div>
          <div className="text-[10px] font-medium leading-4 text-gray-500">
            {t("Manage your payment methods")}
          </div>
        </div>
      </div>
    );
  };

  const renderCard = () => {
    if (paymentMethod.get("id")) {
      const brand = paymentMethod.getIn(["card", "brand"]) || "";
      const last4 = paymentMethod.getIn(["card", "last4"]) || "";
      const expMonth = paymentMethod.getIn(["card", "expMonth"]) || "";
      const expYear = paymentMethod.getIn(["card", "expYear"]) || "";
      return (
        <div className="border border-gray-200 rounded-lg bg-gray-50 p-3 flex items-center gap-3 shadow-[0px_1px_1px_0px_rgba(0,0,0,0.05)]">
          <div className="w-10 h-10 p-1.5 rounded-full bg-gray-50 flex items-center justify-center">
            <img
              className="w-full h-full object-contain"
              src={getUrlCardByBrand(String(brand))}
              alt={String(brand)}
            />
          </div>
          <div className="min-w-0 flex-1">
            <div className="text-[12px] font-semibold text-gray-900 leading-4 truncate">
              {`${String(brand).toUpperCase()} *${last4}`}
            </div>
            <div className="text-[10px] text-gray-500 leading-4 mt-0.5">
              {t("Expires")} {expMonth}/{expYear}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="py-6 flex items-center justify-center">
        <div className="text-center">
          <img
            src={`${getBaseUrl()}/static/images/empty-state.png`}
            className="h-24 mx-auto object-contain"
            alt="Empty state"
          />
          <div className="text-[12px] text-gray-500 mt-3">{t("Add your first card")}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white border border-gray-200 rounded-[12px]">
      {renderHeader()}
      <div className="px-3 pb-3">{renderCard()}</div>
    </div>
  );
};

export default PaymentCard;
